import { connect } from 'react-redux';
import RoomAdminProfile from './RoomAdminProfile';

const mapStateToProps = (state) => ({
  reviewsTotal: state.Room.room.reviewsTotal,
  reviews: state.Room.room.reviews,
});

export default connect(mapStateToProps)(RoomAdminProfile);
